import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const pulse = keyframes({
  "0%, 100%": {
    transform: "scale(1)",
    opacity: 1,
  },
  "50%": {
    transform: "scale(1.3)",
    opacity: 0.5,
  },
});

const fadeInOut = keyframes({
  "0%, 100%": {
    opacity: 0,
  },
  "50%": {
    opacity: 1,
  },
});

export const Image = styled.img({
  width: 64,
  height: 64,
  animation: `${pulse} 1.8s ease-in-out infinite`,
});

export const AnimatedText = styled(Typography)<{ delay: number }>(({ delay }) => ({
  opacity: 0,
  animation: `${fadeInOut} 2.4s ease-in-out infinite`,
  animationDelay: `${delay}s`,
}));
